import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimType.ListPublic.IRequest;
type Response = Api.Core.ClaimType.ListPublic.IResponse;
type Headers = Api.Core.ClaimType.ListPublic.IHeaders;
const url = '/api/Public/ClaimType';
export default async function claimTypeListPublicApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
